import { useCallback, useRef, useState } from 'react';
import { DepositListItem } from '@/components/organisms';
import { IDepositInfo, IDepositItem } from '@/types';
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';
import { Navigation, SwiperOptions } from 'swiper';
import { clickEventHandler, makeTwoDimensionalArray } from '@/helpers';
import { ButtonOutline } from '@/components/atoms';
import { ButtonWrapper, Wrapper } from './CollectDeposit.styled';
import { IntersectionObserver } from '@/components/common';
import { useLoading, useDeviceId, useCommonParams } from '@/hooks';
import { COMPONENT_TYPE } from '@/const';

const swiperSettings: SwiperOptions = {
  slidesPerView: 1,
  navigation: {
    nextEl: '.swiper-button-next-deposit',
  },
  loop: true,
  autoHeight: true,
};

const CollectDeposit = (props: IDepositInfo) => {
  const { ads = [] } = props;
  const commonParams = useCommonParams();
  const [deviceId] = useDeviceId();
  const [, setLoading] = useLoading();
  const swiperRef = useRef<SwiperRef>(null);

  const [activeIndex, setActiveIndex] = useState(1);
  const depositList = makeTwoDimensionalArray(ads, 3);

  const handleClickDeposit = useCallback(
    async (item: IDepositItem) => {
      await clickEventHandler({
        ...item,
        ...commonParams,
        setLoading,
        deviceId,
        componentName: COMPONENT_TYPE.DEPOSIT,
      });
    },
    [commonParams, setLoading, deviceId],
  );

  const handleClickNextButton = () => {
    swiperRef.current && setActiveIndex(swiperRef.current.swiper.realIndex + 1);
  };
  return (
    <Wrapper>
      {ads.length > 3 && (
        <>
          <Swiper
            modules={[Navigation]}
            ref={swiperRef}
            {...swiperSettings}
            onSlideChange={handleClickNextButton}
          >
            {depositList.map((swiperArrayItem: IDepositItem[], index: number) => (
              <SwiperSlide key={`collect-deposit-${index}`}>
                {swiperArrayItem.map((item: IDepositItem, index: number) => (
                  <IntersectionObserver
                    key={`deposit-item-${index}`}
                    page={commonParams.page}
                    {...item}
                    componentName={COMPONENT_TYPE.DEPOSIT}
                  >
                    <DepositListItem {...item} onClick={() => handleClickDeposit(item)} />
                  </IntersectionObserver>
                ))}
              </SwiperSlide>
            ))}
          </Swiper>
          <ButtonWrapper>
            <ButtonOutline
              className="swiper-button-next-deposit"
              full
              onClick={handleClickNextButton}
            >
              다음보기 {activeIndex}/<span style={{ color: '#CCCCCC' }}>{depositList.length}</span>
            </ButtonOutline>
          </ButtonWrapper>
        </>
      )}
      {ads.length <= 3 &&
        ads.map((item: IDepositItem, index: number) => (
          <IntersectionObserver
            key={`collect-deposit-${index}`}
            {...item}
            componentName={COMPONENT_TYPE.DEPOSIT}
          >
            <DepositListItem {...item} onClick={() => handleClickDeposit(item)} />
          </IntersectionObserver>
        ))}
    </Wrapper>
  );
};

export default CollectDeposit;
